// Utilitaires d'adresse : évite les doublons "CP Ville" quand l'adresse
// enregistrée (autocomplétion Google, import…) les contient déjà.

const esc = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Retire le pays et le CP/ville s'ils sont déjà présents à la fin de l'adresse. */
export function stripCpVille(adresse?: string, cp?: string, ville?: string, pays?: string): string {
  let base = (adresse || '').trim().replace(/\s+/g, ' ').replace(/[,\s]+$/, '');
  if (!base) return '';
  const tail = (v?: string, requireComma = false) => {
    const val = String(v || '').trim();
    if (!val) return;
    const sep = requireComma ? '\\s*,\\s*' : '(?:\\s*,\\s*|\\s+)';
    const re = new RegExp(`${sep}${esc(val)}$`, 'i');
    if (re.test(base)) base = base.replace(re, '').replace(/[,\s]+$/, '');
  };
  // ordre du plus spécifique au plus général
  // le pays n'est retiré que s'il constitue un segment séparé par une virgule
  // (sinon « 24 avenue Anatole France » perdrait la fin de son libellé)
  tail(pays || 'France', true);
  tail([cp, ville].filter(Boolean).join(' '));
  tail(ville, true);
  tail(cp);

  return base.trim();
}

/** Adresse complète sur une seule ligne, sans doublon de CP/ville. */
export function normalizeAdresse(adresse?: string, cp?: string, ville?: string, sep = ', '): string {
  const base = stripCpVille(adresse, cp, ville);
  const cpVille = [cp, ville].filter(Boolean).join(' ').trim();
  return [base, cpVille].filter(Boolean).join(sep);
}

/** Adresse en 2 lignes : [rue, "CP Ville"], sans doublon. */
export function adresseLignes(adresse?: string, cp?: string, ville?: string): [string, string] {
  return [stripCpVille(adresse, cp, ville), [cp, ville].filter(Boolean).join(' ').trim()];
}
